module.exports = __webpack_public_path__ + "img/case_deli.98f84a25.png";